import i18next from 'i18next';

import en from './assets/locales/en.json';
import tw from './assets/locales/zh-tw.json';

import { initReactI18next } from 'react-i18next';
import config from 'config';

const resources = {
  en: {
    translation: en
  },
  'zh-TW': {
    translation: tw
  }
};

// 自定義 postProcessor 用於替換品牌名稱
const brandReplacer = {
  type: 'postProcessor' as const,
  name: 'brandReplacer',
  process (value: string) {
    if (!config.isUat) {
      return value;
    }
    return value.replace(/PChome RMN/g, 'RMN').replace(/PChome/g, 'RMN');
  }
};

i18next
  .use(initReactI18next)
  .use(brandReplacer)
  .init({
    resources,
    // lng: navigator.language || 'zh-TW',
    lng: 'zh-TW',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    postProcess: ['brandReplacer']
  });

export default i18next;
